var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshFill1Wght500Grad0Opsz48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.5 35.7",
    style: {
      enableBackground: "new 0 0 36.5 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B454E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,34.5c-4.5,0-8.3-1.6-11.5-4.8s-4.8-7-4.8-11.5c0-4.5,1.6-8.3,4.8-11.5s7-4.8,11.5-4.8 c2.9,0,5.4,0.6,7.6,1.8c2.2,1.2,4.1,2.8,5.6,4.8V1.9h3.2V15H21.4v-3.1h8.4c-1.3-2-2.9-3.6-4.8-4.8s-4.2-1.8-6.8-1.8 C14.5,5.3,11.5,6.5,9,9s-3.8,5.6-3.8,9.1c0,3.6,1.3,6.6,3.8,9.2s5.6,3.8,9.1,3.8c2.7,0,5.2-0.8,7.5-2.3s3.9-3.6,4.8-6.2H34 c-1,3.6-3,6.4-5.9,8.6C25.2,33.4,21.9,34.5,18.1,34.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshFill1Wght500Grad0Opsz48);
export default __webpack_public_path__ + "static/media/refresh_FILL1_wght500_GRAD0_opsz48.a6aa53a413e972c963b898c909279e99.svg";
export { ForwardRef as ReactComponent };